import { render, staticRenderFns } from "./BankTransfers.vue?vue&type=template&id=2d2da57a&scoped=true&"
import script from "./BankTransfers.vue?vue&type=script&lang=js&"
export * from "./BankTransfers.vue?vue&type=script&lang=js&"
import style0 from "./BankTransfers.vue?vue&type=style&index=0&id=2d2da57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2da57a",
  null
  
)

export default component.exports